import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from '../../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { ValueAdapter } from '../../value.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { SalesforceServiceCloudCopySource } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SalesforceServiceCloudCopySource),
    disabled: __IS_FABRIC_DPE__,
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*',
        readBehavior: '*'
    }
})
export class SalesforceServiceCloudCopySourceAdapter extends CopySourceAdapter<
    SalesforceServiceCloudCopySource,
    Model.SalesforceServiceCloudSource
> {
    protected override async _toResource(
        copySource: SalesforceServiceCloudCopySource
    ): Promise<Model.SalesforceServiceCloudSource> {
        const result: Model.SalesforceServiceCloudSource = this.getCommonCopySourceProperties(
            copySource,
            'SalesforceServiceCloudSource'
        );
        if (copySource.mode === 'query') {
            result.query = ValueAdapter.toResource(copySource, SalesforceServiceCloudCopySource.READER_QUERY);
        }
        result.readBehavior = ValueAdapter.toResource(copySource, SalesforceServiceCloudCopySource.READ_BEHAVIOR);
        return result;
    }

    protected override async _toModel(
        resource: Model.SalesforceServiceCloudSource,
        copyActivity: CopyActivity
    ): Promise<SalesforceServiceCloudCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            SalesforceServiceCloudCopySource.MODEL,
            resource,
            copyActivity
        ) as SalesforceServiceCloudCopySource;
        if (resource.query) {
            ValueAdapter.toModel(result, SalesforceServiceCloudCopySource.READER_QUERY, resource.query);
            result.mode = 'query';
        }
        ValueAdapter.toModel(result, SalesforceServiceCloudCopySource.READ_BEHAVIOR, resource.readBehavior);
        return result;
    }
}
